import $ from 'jquery';
import { breakpoint } from '../variables/variables.js';
import { createSwiperToggle, } from '../functions/functions.js';

// Квартиры и помещения
$( () => {
	if ( ! $( '.properties-slider' ).length ) {
		return;
	}

	createSwiperToggle( '.properties-slider', () => {
		return breakpoint.isTablet;
	} );
} );
